import loadable from '@loadable/component';
import { ClientOnly } from 'remix-utils/client-only';
import type { EnvironmentModalProps } from './index';

const EnvironmentModal = loadable(() => import('./index'), {
  fallback: <></>,
});

export default function AsyncEnvironmentModal(props: EnvironmentModalProps) {
  return <ClientOnly fallback={null}>{() => <EnvironmentModal {...props} />}</ClientOnly>;
}
